import { t } from '../i18n';

export function NavBar(activeTab = 'home') {
  const tabs = [
    { id: 'home', icon: '🏠', label: t('nav_home') },
    { id: 'games', icon: '🎮', label: t('nav_levels') },
    { id: 'invite', icon: '🎁', label: t('nav_invite') },
    { id: 'premium', icon: '🪙', label: t('nav_premium') },
    { id: 'profile', icon: '😎', label: t('nav_profile') },
  ];

  return `
    <nav class="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] h-nav-h bg-[#0D0B1A]/95 backdrop-blur-[24px] saturate-[1.8] border-t border-white/5 flex items-start justify-around pt-2.5 z-50">
      ${tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const textColor = tab.id === 'premium' && isActive ? 'text-neon-gold' : isActive ? 'text-neon-pink' : 'text-t-muted';
        const iconShadow = tab.id === 'premium' ? 'drop-shadow-[0_0_6px_rgba(255,215,0,0.5)]' : '';
        const iconTransform = isActive ? 'scale-110 -translate-y-0.5' : '';
        const indicator = isActive ? `<div class="absolute -bottom-2.5 left-1/2 -translate-x-1/2 w-5 h-[3px] bg-grad-primary rounded-full"></div>` : '';

        return `
          <div data-nav="${tab.id}" class="flex flex-col items-center gap-1 cursor-pointer px-3 py-1.5 rounded-md transition-all duration-200 relative group">
            <span class="text-[20px] transition-transform duration-200 ${iconTransform} ${iconShadow} group-active:scale-95 group-active:-translate-y-0 text-center">
              ${tab.icon}
            </span>
            <span class="text-[10px] font-bold tracking-[0.3px] transition-colors duration-200 ${textColor}">
              ${tab.label}
            </span>
            ${indicator}
          </div>
        `;
      }).join('')}
    </nav>
  `;
}
